import { patchRequest } from '@helpers/request'
import { logger } from '@helpers/logger.js'

export const linkEventToSportDb = async (data) => {
  try {
    const { response, logComplete } = await patchRequest('eventAdmin/linkEvents', data)
    logComplete()
    return response
  } catch (error) {
    logger.error('linkEventToSportDb', error)
    throw error
  }
}

/**
 * Cleans event data by removing temporary properties that shouldn't be persisted
 * @param {Object} eventData - The event data to clean
 * @returns {Object} - Cleaned event data
 */
const cleanEventDataForUpload = (eventData) => {
  const {
    // Remove temporary SportDB flag 
    isNewSportDbEvent, // eslint-disable-line 
    ...cleanedEventData
  } = eventData

  return cleanedEventData
}

export const addEventToLeague = async (eventData, sport, league, season) => {
  try {
    // Clean the event data to remove temporary properties before upload
    const cleanedEventData = cleanEventDataForUpload(eventData)

    const { response, logComplete } = await patchRequest('eventAdmin/addEventToLeague', {
      eventData: cleanedEventData,
      sport,
      league,
      season,
    })
    logComplete()
    return response
  } catch (error) {
    logger.error('addEventToLeague', error)
    throw error
  }
}

export const endTournament = async (sport, league, season) => {
  try {
    const { response, logComplete } = await patchRequest('seasonAdmin', {
      sport,
      league,
      season,
      isComplete: true,
    })
    logComplete()
    return response
  } catch (error) {
    logger.error('endTournament', error)
    throw error
  }
}
